/* TODO The purpose of this adapter is not to include not used stuff in widget.
It can be removed after adapters refactoring to separate methods */

import withEventTriggering from '../../utils/with-events-triggering';
import provideEachCallEvents from '../../utils/provide-each-call-events';

import initPremium from './premium';
import initList from './list';
import initLists from './lists';
import initItem from './item';
import initItems from './items';
import initItemActions from './item-actions';
import initListItems from './list-items';
import initWidgets from './widgets';

import events from './events/index';

import defaultSettings from './default-settings';

function addEventsTriggering(methodsGroups) {
  _.forEach(methodsGroups, function (methods, groupName) {
    groupName = _.snakeCase(groupName).toUpperCase();
    _.forEach(methods, function (method, key) {
      const name = _.snakeCase(key).toUpperCase();
      methods[key] = withEventTriggering(method, `VOD.${groupName}.${name}`);
    });
  });
}

function wrapWithEventsProviding(methodsGroups, globalTrigger) {
  return _.mapValues(methodsGroups, function (methods) {
    return _.mapValues(methods, function (method) {
      return provideEachCallEvents(method, globalTrigger);
    });
  });
}

export default function VOD(userSettings) {
  const _settings = _.assign({}, defaultSettings, userSettings);

  const methodsGroups = {};
  methodsGroups.premium = initPremium(_settings, methodsGroups);
  methodsGroups.list = initList(_settings, methodsGroups);
  methodsGroups.lists = initLists(_settings, methodsGroups);
  methodsGroups.item = initItem(_settings, methodsGroups);
  methodsGroups.itemActions = initItemActions(_settings, methodsGroups);
  methodsGroups.items = initItems(_settings, methodsGroups);
  methodsGroups.listItems = initListItems(_settings, methodsGroups);
  methodsGroups.widgets = initWidgets(_settings, methodsGroups);
  addEventsTriggering(methodsGroups);

  _.assign(
    this,
    { events },
    wrapWithEventsProviding(methodsGroups, (...args) => events.trigger(...args))
  );
}



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/vod-lite.js